<template>
    <div>
        <page-navigate></page-navigate>
        <div id="pageContainer">
            <section class="container1">
                <div class="flex contentBox justify-between">
                    <div class="left">
                        <h1 class="super_large-72_bold md-title-32_bold word1">股票差价合约</h1>
                        <h2 class="subtitle-20_regular md-body-14_regular word2">
                            交易全球热门美股差价合约，涵盖Apple、Tesla、Meta、Nvidia、Google、Microsoft、Amazon等知名企业股票
                        </h2>
                        <a :href="signupUrl" target="_blank">
                            <div class="pageBtn primary-default_large">
                                <span class="word3">立即开户</span>
                                <span class="iconfont icon-right"></span>
                            </div>
                        </a>
                    </div>
                    <img class="right" src="@/assets/image/trading-product/tradingproductShareCfds.png?t=1111"
                        alt="" />
                </div>
            </section>
            <product-tab></product-tab>
            <section class="container2">

                <div class="contentBox container2Content">
                    <h2 class="text-center title-48_bold md-title-24_bold scroll-fade-up word4 scroll-fade-up">产品优势</h2>
                    <h3 class="text-center subtitle-20_regular md-footnote-regular_12 word5 scroll-fade-up">
                        通过美股差价合约，享受灵活杠杆、无印花税及无需持股的优势，让您轻松参与全球市场，捕捉交易机会
                    </h3>
                    <a href="https://edocs-1305385874.cos.ap-hongkong.myqcloud.com/web/EBC PRODUCT GUIDE_CN.pdf"
                        target="_blank">
                        <div class="primary-default_large jyBtn scroll-fade-up">交易产品指南</div>
                    </a>
                    <div class="topCardList flex scroll-fade-up">
                        <div class="card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34"
                                fill="none">
                                <g clip-path="url(#clip0_2526_19567)">
                                    <path
                                        d="M3.06387 28.2818V23.9113C3.06387 23.7548 3.03606 23.5983 2.9839 23.4488C2.49713 22.0754 0.084123 14.5652 2.08685 10.9144C4.29124 6.89156 8.27931 0.911194 8.27931 0.911194C8.27931 0.911194 11.0991 1.79782 9.14854 5.2852L7.03803 8.74825M6.54087 16.0078V8.74448C6.54087 8.74448 9.53105 9.1791 9.53105 11.7868C9.53105 13.7374 9.64232 14.93 10.0248 16.4981C10.1569 17.0405 10.4281 18.3896 10.6263 19.3979C10.7828 20.1976 11.0331 21.192 10.8106 21.9778L10.0213 24.0709V28.5457M1.30439 33.0832V28.737H11.7561V33.0832H1.30439Z"
                                        stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M31.7382 28.2818V23.9113C31.7382 23.7548 31.766 23.5983 31.8182 23.4488C32.3049 22.0754 34.7179 14.5652 32.7152 10.9144C30.5108 6.88808 26.5227 0.907715 26.5227 0.907715C26.5227 0.907715 23.7029 1.79434 25.6535 5.28172L27.764 8.74477M28.2614 16.0078V8.74446C28.2614 8.74446 25.2712 9.17908 25.2712 11.7868C25.2712 13.7374 25.16 14.93 24.7775 16.4981C24.6454 17.0405 24.3742 18.3895 24.176 19.3979C24.0195 20.1976 23.7692 21.192 23.9917 21.9778L24.781 24.0709V28.5457M23.0459 33.0832V28.737H33.4976V33.0832H23.0459Z"
                                        stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M23.0045 9.18321C23.0045 9.18321 23.0045 9.21798 23.0045 9.23537C20.1013 9.60045 17.803 11.8987 17.4379 14.802C17.4206 14.802 17.4032 14.802 17.3893 14.802C17.3719 14.802 17.3545 14.802 17.3371 14.802C16.972 11.8987 14.6738 9.60045 11.7705 9.23537C11.7705 9.21798 11.7705 9.2006 11.7705 9.18321C11.7705 9.16583 11.7705 9.14844 11.7705 9.13106C14.6703 8.76598 16.972 6.46771 17.3371 3.56445C17.3545 3.56445 17.3719 3.56445 17.3893 3.56445C17.4067 3.56445 17.424 3.56445 17.4379 3.56445C17.803 6.46771 20.1013 8.76598 23.0045 9.13106C23.0045 9.14844 23.0045 9.16583 23.0045 9.18321Z"
                                        stroke="#A52933" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_2526_19567">
                                        <rect width="33.0624" height="33.0415" fill="white"
                                            transform="translate(0.870117 0.476929)" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <h3 class="title-24_medium md-body-16_medium word6">多元化的产品选择</h3>
                            <div class="desc content-16_regular md-footnote-regular_12 word7">
                                精选150只热门股票,灵活覆盖多种投资偏好,满足不同交易需求</div>
                        </div>
                        <div class="card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40"
                                fill="none">
                                <g clip-path="url(#clip0_2526_19577)">
                                    <path
                                        d="M17.415 2.74512V2.24512H17.415L17.415 2.74512ZM24.3447 6.77539L23.9104 7.02315C24.0339 7.23959 24.2979 7.33208 24.5295 7.24001L24.3447 6.77539ZM26.626 6.33984L26.626 5.83984H26.626V6.33984ZM32.7812 12.0156L32.2829 12.0557C32.3017 12.2902 32.4815 12.4798 32.7146 12.5112L32.7812 12.0156ZM38.4199 18.4697H38.9199V18.4697L38.4199 18.4697ZM32.3545 24.9678L32.3205 24.4689C32.0582 24.4868 31.8545 24.7048 31.8545 24.9678H32.3545ZM32.3545 24.9844V25.4844C32.6306 25.4844 32.8545 25.2605 32.8545 24.9844H32.3545ZM9.44043 24.9844H8.94043C8.94043 25.2605 9.16429 25.4844 9.44043 25.4844V24.9844ZM9.44043 24.9688H9.94043C9.94043 24.7042 9.73436 24.4854 9.47029 24.4696L9.44043 24.9688ZM2.47656 17.5713L1.97656 17.5713V17.5713H2.47656ZM9.46094 10.1709L9.48942 10.6701C9.74107 10.6557 9.94268 10.4563 9.95978 10.2048L9.46094 10.1709ZM17.415 2.74512V3.24512C20.1968 3.24512 22.6227 4.76592 23.9104 7.02315L24.3447 6.77539L24.779 6.52763C23.321 3.97179 20.571 2.24512 17.415 2.24512V2.74512ZM24.3447 6.77539L24.5295 7.24001C25.1777 6.98225 25.8847 6.83984 26.626 6.83984V6.33984V5.83984C25.7556 5.83984 24.9234 6.00725 24.16 6.31077L24.3447 6.77539ZM26.626 6.33984L26.626 6.83984C29.6059 6.83994 32.0482 9.13603 32.2829 12.0557L32.7812 12.0156L33.2796 11.9756C33.0036 8.54099 30.1317 5.83996 26.626 5.83984L26.626 6.33984ZM32.7812 12.0156L32.7146 12.5112C35.6534 12.9062 37.9197 15.4231 37.9199 18.4698L38.4199 18.4697L38.9199 18.4697C38.9197 14.9152 36.2759 11.9809 32.8479 11.5201L32.7812 12.0156ZM38.4199 18.4697H37.9199C37.9199 21.6517 35.4484 24.2558 32.3205 24.4689L32.3545 24.9678L32.3885 25.4666C36.0372 25.2181 38.9199 22.1815 38.9199 18.4697H38.4199ZM32.3545 24.9678H31.8545V24.9844H32.3545H32.8545V24.9678H32.3545ZM32.3545 24.9844V24.4844H9.44043V24.9844V25.4844H32.3545V24.9844ZM9.44043 24.9844H9.94043V24.9688H9.44043H8.94043V24.9844H9.44043ZM9.44043 24.9688L9.47029 24.4696C5.84772 24.2529 2.97656 21.2481 2.97656 17.5713H2.47656H1.97656C1.97656 21.7809 5.26351 25.2197 9.41057 25.4679L9.44043 24.9688ZM2.47656 17.5713L2.97656 17.5713C2.97664 13.8878 5.85799 10.8773 9.48942 10.6701L9.46094 10.1709L9.43245 9.67171C5.2749 9.90896 1.97665 13.3545 1.97656 17.5713L2.47656 17.5713ZM9.46094 10.1709L9.95978 10.2048C10.2242 6.31714 13.4603 3.24528 17.4151 3.24512L17.415 2.74512L17.415 2.24512C12.9305 2.2453 9.26192 5.72846 8.96209 10.137L9.46094 10.1709Z"
                                        fill="#9F734C" />
                                    <path d="M30.4682 13.2898C30.4682 10.8544 28.4939 8.88019 26.0586 8.88019"
                                        stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                                    <rect x="9.37891" y="21.1503" width="9.20261" height="5.36819" fill="white"
                                        stroke="#A52933" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M15.3223 23.8344H18.5815" stroke="#A52933" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <circle cx="11.6809" cy="23.8344" r="0.766885" fill="#A52933" />
                                    <path d="M22.416 21.1503H31.6186V26.5185H22.416V21.1503Z" fill="white"
                                        stroke="#A52933" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M28.3594 23.8344H31.6186" stroke="#A52933" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <circle cx="24.7161" cy="23.8344" r="0.766885" fill="#A52933" />
                                    <path d="M10.5293 28.244V31.3116H30.0849V28.244M20.6905 29.0109V34.3791"
                                        stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                                    <circle cx="20.6897" cy="35.9129" r="1.34205" stroke="#A52933"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_2526_19577">
                                        <rect width="40" height="40" fill="white" transform="translate(0.5)" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <h3 class="title-24_medium md-body-16_medium word8">无需持有实际股票</h3>
                            <div class="desc content-16_regular md-footnote-regular_12 word9">
                                降低资金门槛,简化教育流程,轻松参与市场机会
                            </div>
                        </div>
                        <div class="card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"
                                fill="none">
                                <g clip-path="url(#clip0_2526_19601)">
                                    <path d="M38.1735 32.9109H2.04102V37.7286H38.1735V32.9109Z" stroke="#9F734C"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <rect x="8.60938" y="18.0199" width="4.3797" height="9.19737" stroke="#9F734C"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <rect x="15.1797" y="15.8301" width="3.94173" height="11.3872" stroke="#9F734C"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path
                                        d="M16.0557 33.1299V34.8817H24.3771V33.1299M4.23047 32.7592V10.5744H25.691M28.5378 10.5744H36.6402V32.7592"
                                        stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                                    <ellipse cx="27.934" cy="15.5237" rx="5.62154" ry="5.69361" fill="white"
                                        stroke="#A52933" stroke-linecap="round" stroke-linejoin="round" />
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M27.7477 15.9226C27.7224 15.9112 27.6969 15.8997 27.671 15.8879L27.7477 15.9226Z"
                                        fill="#A52933" />
                                    <path
                                        d="M27.671 15.8879L27.7477 15.9226C28.0314 16.0507 28.2756 16.161 28.4591 16.301C28.6462 16.4436 28.7355 16.5908 28.7355 16.7919C28.7355 16.9625 28.6793 17.08 28.5821 17.1616C28.4772 17.2496 28.295 17.3195 28.0065 17.3195C27.5493 17.3195 27.1571 17.1234 26.8155 16.8657C26.7222 16.7953 26.5975 16.8023 26.5118 16.8766L26.4776 16.9127L26.1432 17.3397C26.1 17.3949 26.0799 17.4667 26.0875 17.5379C26.0952 17.6091 26.13 17.6739 26.1837 17.7176C26.5424 18.009 27.0487 18.2435 27.5699 18.3335V18.8647C27.5699 19.0107 27.6819 19.129 27.8199 19.129H28.3326C28.4707 19.129 28.5826 19.0107 28.5826 18.8647V18.3097C28.9402 18.2315 29.2501 18.0773 29.484 17.8466C29.7687 17.5659 29.9269 17.1875 29.9269 16.7506C29.9269 16.2561 29.7404 15.8968 29.4659 15.6308C29.2029 15.376 28.8622 15.2103 28.5577 15.0753C28.4939 15.0471 28.4321 15.0202 28.3723 14.9943C28.1305 14.8894 27.9234 14.7996 27.7599 14.6887C27.568 14.5584 27.4952 14.4383 27.4952 14.285C27.4952 14.1388 27.5479 14.0293 27.6398 13.9509C27.7368 13.8682 27.8964 13.8053 28.1232 13.8053C28.3317 13.8054 28.4822 13.8401 28.6119 13.8983C28.7447 13.9578 28.8687 14.0479 29.0211 14.1796C29.1176 14.2631 29.2577 14.2587 29.3492 14.1693L29.7301 13.7971C29.782 13.7463 29.811 13.6746 29.8102 13.5999C29.8093 13.5251 29.7787 13.4542 29.7257 13.4047C29.4303 13.1298 29.0835 12.8909 28.5826 12.794V12.2602C28.5826 12.1142 28.4707 11.9958 28.3326 11.9958H27.8199C27.6819 11.9959 27.5699 12.1142 27.5699 12.2602V12.8167C26.8426 12.9878 26.3039 13.5262 26.3038 14.3123C26.3038 14.7787 26.4983 15.1126 26.7716 15.3583C27.0325 15.5927 27.3711 15.752 27.671 15.8879Z"
                                        fill="#A52933" />
                                    <path d="M26.6667 9.83087V6.73569H24L28 2L32 6.73569H29.5556V10" stroke="#A52933"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M26.6667 21.1691V24.2643H24L28 29L32 24.2643H29.5556V21" stroke="#A52933"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_2526_19601">
                                        <rect width="40" height="40" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <h3 class="title-24_medium md-body-16_medium word10">多空双向交易</h3>
                            <div class="desc content-16_regular md-footnote-regular_12 word11">
                                通过CFD支持多空双向交易,无论股价涨跌均有获利机会</div>
                        </div>
                        <div class="card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40"
                                fill="none">
                                <path d="M32.404 30.9487H8.51562V34.7402H32.404V30.9487Z" stroke="#9F734C"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16.4124 10.0126L8.51562 12.3469L10.181 11.8554L18.9003 9.30621"
                                    stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M32.4031 5.25922L24.595 7.56615L23.4483 7.904L30.823 5.72675L30.6626 5.80182L21.9434 8.35106"
                                    stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M20.459 10.0639V30.9492" stroke="#9F734C" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M20.4662 10.0638C21.1768 10.0638 21.7528 9.48777 21.7528 8.77722C21.7528 8.06667 21.1768 7.49066 20.4662 7.49066C19.7557 7.49066 19.1797 8.06667 19.1797 8.77722C19.1797 9.48777 19.7557 10.0638 20.4662 10.0638Z"
                                    stroke="#A52933" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M12.3897 19.5002C12.3454 21.6058 10.6254 23.2883 8.51297 23.2883C6.40055 23.2883 4.67376 21.6058 4.63281 19.4968"
                                    stroke="#A52933" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M12.4019 19.4965C10.2553 19.4965 8.51149 17.7561 8.51149 15.6061C8.51149 17.7527 6.77105 19.4965 4.62109 19.4965"
                                    stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M36.2789 12.6749C36.2345 14.7805 34.5146 16.4629 32.4021 16.4629C30.2897 16.4629 28.5663 14.777 28.5254 12.6714"
                                    stroke="#A52933" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M36.2886 12.6745C34.1421 12.6745 32.3982 10.934 32.3982 8.78406C32.3982 10.9306 30.6578 12.6745 28.5078 12.6745"
                                    stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <h3 class="title-24_medium md-body-16_medium word12">灵活的杠杆</h3>
                            <div class="desc content-16_regular md-footnote-regular_12 word13">
                                带杠杆的股票交易,最高可达五倍,以较少的资金获得更大的市场曝光,提升投资回报</div>
                        </div>
                    </div>
                    <h2 class="text-center title-48_bold md-title-24_bold scroll-fade-up">市场报价</h2>
                    <div id="pageOverLay"></div>
                    <product-module-new />
                </div>
            </section>
            <open-account></open-account>
            <section class="container4 commonQuestion">
                <div class="contentBox">
                    <h2 class="scroll-fade-up">常见问题</h2>
                    <div class="QA-list">
                        <div class="QA-item">
                            <div class="QA-title">1.什么是股票CFD？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    股票CFD（差价合约）是一种金融衍生品，使投资者可以无需实际持有股票即可通过价格波动获利。
                                </p>
                                <p class="QA-li">
                                    通过交易股票CFD，投资者可以规避传统股票交易中的额外成本（如印花税），同时享受多空双向交易的灵活性，无论市场涨跌均可把握机会。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">2. 股票CFD可以交易什么？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    EBC精选150支全球热门美股，为投资者提供具有竞争力的交易成本和多空双向操作的灵活性。结合卓越的流动性支持，EBC确保投资者的交易体验更高效、更便捷。
                                </p>
                            </div>
                        </div>

                        <div class="QA-item">
                            <div class="QA-title">3. 股票CFD交易杠杆</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    EBC股票CFD提供1:5杠杆，投资者仅需少量资金即可参与全球顶尖企业的投资，扩大收益潜力。但需注意，杠杆虽然使投资者能够以较低的成本参与更大规模的交易，有效提高资金利用率，但同样会放大市场波动带来的风险，不利行情可能导致更大的损失。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">4. 如何参与股票CFD交易？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    股票CFD交易与传统股票交易类似，但无需实际持有股票。交易价格受企业财务状况及市场表现的影响。
                                </p>
                                <p class="QA-li">
                                    投资者在参与前，应了解企业的财务指标（如市盈率、市净率）以评估其投资价值。例如，当企业市盈率低于行业平均水平时，可能存在被低估的投资机会。
                                </p>
                                <p class="QA-li">
                                    EBC甄选全球范围内流动性强、财务表现优异的公司，助力投资者精准发掘价值潜力。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">5. 股票CFD如何获得股息？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    在股票CFD交易中，投资者同样有机会享受股息收益。例如，当某公司宣布每股派息0.32美元，投资者持有10000股相关CFD，即可获得3200美元的股息收入。
                                </p>
                                <p class="QA-li">
                                    在EBC平台交易股票CFD，只需在除息日前一天持有相关CFD合约，即可在派息日收到股息收益。
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
        <message-v3></message-v3>

        <page-footer></page-footer>
    </div>
</template>

<script>
import fadeAnimate from "../mixins/fadeAnimate.js";
import {
    mapGetters,
} from 'vuex'
export default {
    mixins: [fadeAnimate],
    data() {
        return {
            infoData: "",
            newData: "",
            pagIndex: 0,
            num: 3,
            newsdisplay: "none"
        }
    },
    computed: {
        ...mapGetters([
            'signupUrl',
        ]),
    },
    destroyed() {
    },

    mounted() {
        this.initPage()
    },
    methods: {
        initPage() {
            const setTabActIdx = (idx, e) => {
                scrollTabElement.forEach((item, index) => {
                    item.classList.remove("active");
                });
                floatTabElement.forEach((item, index) => {
                    item.classList.remove("active");
                });
                floatTabElement[idx].classList.add("active");
                scrollTabElement[idx].classList.add("active");
                const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
                const leftPad = 32 * rem;
                const wrapper = document.querySelector(".scrollTabWrapper");
                wrapper.scrollLeft = idx <= 1 ? 0 : e.target.offsetLeft - leftPad;
            };
            const scrollTabElement = document.querySelectorAll(
                ".scrollTabWrapper .tabItem"
            );
            const floatTabElement = document.querySelectorAll(".floatTab .tabItem");
            floatTabElement.forEach((item, idx) => {
                item.addEventListener("click", function (e) {
                    jumpPage(idx);
                });
            });
            scrollTabElement.forEach((item, idx) => {
                item.addEventListener("click", function (e) {
                    jumpPage(idx);
                });
            });
            let tabIndex = 0;

            if (location.href.includes("/commodity/")) {
                tabIndex = 1;
            } else if (location.href.includes("/index-cfds/")) {
                tabIndex = 2;
            } else if (location.href.includes("/share-cfds/")) {
                tabIndex = 3;
            } else if (location.href.includes("/etf/")) {
                tabIndex = 4;
            } else if (location.href.includes("/crypto/")) {
                tabIndex = 5;
            }
            setTabActIdx(tabIndex, { target: floatTabElement[tabIndex] });
            setTabActIdx(tabIndex, { target: scrollTabElement[tabIndex] });
            function jumpPage(idx) {
                const pathArr = location.pathname.split("/");
                const len = pathArr.length;
                const targetArr = ["forex", "commodity", "index-cfds", "share-cfds", "etf", 'crypto'];
                pathArr[len - 2] = targetArr[idx];
                location.href = pathArr.join("/");
            }
            debugger
            console.log(ProductVM, 1111)
            ProductVM.changeHandle(tabIndex);
            document.addEventListener("mountedSuccess", (e) => {
                ProductVM.changeHandle(tabIndex);
            });



        }
    }
}

</script>
<style scoped lang="scss">
@import url("../assets/css/commonQuestion.scss");

* {
    font-family: Inter, Noto Sans Sc, sans-serif;
}

.message-new .gender-btn::before {
    box-sizing: border-box;
}

.message-new {
    max-width: 1200rem;
    padding-inline: calc((100vw - 1200rem) / 2) !important;
    box-sizing: content-box;
}

.message-new .p1 {
    font-size: 48rem !important;
    line-height: 56rem !important;
}

.contentBox {
    max-width: 1200rem;
    margin-inline: auto;
}

body.no-scroll {
    overflow: hidden;
}

#pageOverLay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
    display: none;
    opacity: 0;
    transition: opacity 0.6s ease;
}

.pageContainer {
    position: relative;
}

#pageContainer {
    background: var(--ebc-neutral-bg_a)
}

#pageContainer .pageBtn {
    gap: 4rem;
    min-width: 180rem;
    width: fit-content;
    cursor: pointer;
}

#pageContainer a {
    width: fit-content;
    display: block;
    margin-inline: auto;
}

.container1 {
    padding-top: calc(80px + 15rem);
    height: 560rem;
    background: var(--ebc-neutral-bg_c);
}

.container1 .left {
    flex: 0 0 770rem;
}

.container1 .left h2 {
    margin: 24rem 0 64rem;
    color: var(--ebc-text-secondary);
}


.container1 .right {
    height: 412rem;
}

.container1 a {
    margin: 0 !important;
}

@media (max-width: 996px) {
    html {
        overflow-x: hidden;
    }

    body {
        overflow-x: visible !important;
    }

    .message-new .p1 {
        font-size: 48rem !important;
        line-height: 72rem !important;
    }

    .container1 {
        padding: 80rem 32rem;
        height: auto;
        overflow-x: hidden;
    }

    .container1 .right {
        /* width: 586rem; */
        height: 586rem;
        margin: 0 auto 80rem;
    }

    .container1>div {
        flex-direction: column;
    }

    .container1 .left {
        order: 2;
        text-align: center;
        flex: 1;
    }

    .container1 .left h2 {
        margin-top: 16rem;
    }

    #pageContainer .container1 a {
        width: 100%;
    }

    #pageContainer .container1 .left .pageBtn {
        width: 100%;
    }

}


.container2 {
    background: var(--ebc-neutral-bg_a);
    margin-top: -64rem;
}

.pt .floatTab,
.es .floatTab {
    width: 900rem;
}

.floatTab {
    position: sticky;
    transform: translateY(-50%);
    z-index: 98;
    top: 128px;
    margin-inline: auto;
    background: var(--ebc-basecolor-white-85);
    border-radius: var(--ebc-corner-radius-full);
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(10px);
    padding: 4rem;
    gap: 8rem;
    width: 792rem;
    height: 64rem;
}

.floatTab .tabItem {
    flex: 1;
    color: var(--ebc-text-secondary);
}

.floatTab .active {
    border-radius: var(--ebc-corner-radius-full);
    background: var(--ebc-neutral-bg_c);
    color: var(--ebc-text-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-weight: 500;
}

.container2 .container2Content {
    padding: 120rem 0;
}

/* .container2 .container2Content>a:last-of-type{
  display:none!important
} */

.container2 h2 {
    margin-bottom: 16rem;
}

.tradingProductPage .container2 h2 {
    max-width: 850rem;
    margin-inline: auto;
}

.container2 h3 {
    max-width: 850rem;
    margin-inline: auto !important;
}

.container2 h3 {
    margin: 16rem 0;
    color: var(--ebc-text-secondary);
}

.container2 .pageBtn {
    margin: 60rem auto 0;
}

@media (max-width: 996px) {
    html {
        height: auto !important;
        min-height: auto !important;
    }

    .container2 {
        padding: 0 32rem;
        margin-top: 0;
    }

    .container2 .container2Content .btnTop {
        height: 64rem;
        font-size: 28rem;
        gap: 8rem;
        line-height: 44rem;
    }

    .container2 .pageBtn {
        height: 80rem;
        font-size: 28rem;
        line-height: 44rem;
        margin-top: 80rem;
    }

    .floatTab {
        display: none !important;
    }

    .container2 .container2Content {
        padding: 64rem 0 160rem;
    }

    .container2 h3 {
        margin: 16rem 0;
    }

    .scrollTab {
        display: inline-flex;
        gap: 16rem;
        min-width: fit-content;
    }

    .scrollTabWrapper {
        overflow-x: auto;
        scroll-behavior: smooth;
        padding: 16rem 32rem;
        margin-top: 64rem;
        background: var(--ebc-neutral-bg_a);
        position: sticky;
        top: 44px;
        z-index: 99
    }

    .scrollTabWrapper::-webkit-scrollbar {
        display: none;
    }

    .scrollTab .tabItem {
        color: var(--ebc-text-secondary);
        padding: 16rem 32rem;
        flex: 1;
        background: var(--ebc-neutral-bg_b);
        border-radius: var(--ebc-corner-radius-full);
        white-space: nowrap;
    }

    .scrollTab .active {
        background: var(--ebc-basecolor-active-500);
        color: var(--ebc-text-primary_white);
        font-weight: 500;
    }
}



.container1 {
    padding-top: 122rem
}

.container1 .left {
    flex: 0 0 590rem;
    padding-top: 38rem;
}

.container1 .contentBox {
    position: relative;
}

.container1 .right {
    position: absolute;
    top: 0;
    left: 171rem;
    height: 438rem;
    pointer-events: none;
}

@media (min-width: 996px) {

    .ug .container1 h1,
    .es .container1 h1 {
        white-space: nowrap;
    }

    .ar .container1 .left {
        padding-top: 0;
    }

    .ar .container1 .right {
        left: unset;
        right: 380rem;
    }

    .mn .container1 h1 {
        font-size: 60rem;
        white-space: nowrap;
        line-height: 68rem;
    }
}

@media (max-width: 996px) {
    .container1 {
        padding-top: 80rem;
    }

    .container1 .left {
        flex: 1;
        padding-top: 494rem;
    }

    .container1 .right {
        max-width: unset;
        height: 530rem;
        margin: 0;
        left: -645rem;
    }
}

.container2 h3 {
    margin: 16rem 0 60rem;
}

.container2 .contentBox {
    padding-top: 88rem;
}

.container2 .topCardList {
    margin-bottom: 120rem;
    gap: 24rem;
    align-items: stretch;
}

.container2 .topCardList .card {
    flex: 1;
    border-radius: var(--ebc-corner-radius-rc16);
    background: var(--ebc-neutral-bg_b);
    padding: 32rem 24rem;
    border: 0;
}

.container2 .topCardList .card:nth-child(2) {
    display: none;
}

.container2 .topCardList .card h3 {
    width: 100%;
    margin: 16rem 0;
    color: var(--ebc-text-primary);
}

.container2 .topCardList .card div {
    color: var(--ebc-text-secondary);
}

.container2 .jyBtn {
    margin-bottom: 60rem;
    min-width: 180rem;
}

@media (max-width: 996px) {
    .container2 .jyBtn {
        height: 80rem;
        margin-bottom: 80rem;
        min-width: unset;
        font-size: 28rem;
        line-height: 44rem;
        font-weight: 500;
    }

    .container2 .topCardList {
        margin-bottom: 160rem;

        gap: 32rem;
        flex-wrap: wrap;
    }

    .container2 .topCardList .card h3 {
        margin: 0rem 0 8rem;
        color: var(--ebc-text-primary);
    }

    .container2 .topCardList .card {
        padding: 32rem;
        padding-left: 128rem;
        flex: 1 0 100%;
        position: relative;
    }

    .container2 .topCardList .card svg {
        position: absolute;
        left: 32rem;
        top: 50%;
        transform: translateY(-50%);
        width: 64rem;
        height: 64rem;
    }
}

.product-table-tr>div:nth-child(4),
.product-table-th>div:nth-child(4) {
    display: none !important;
}
</style>